import { FaGift } from "react-icons/fa";

export default function ReferralHeader() {
  return (
    <section className="rounded-[2rem] border border-white/10 bg-gradient-to-br from-purple-950/80 via-[#10182A] to-blue-950/60 p-6 shadow-2xl">

      <div className="flex items-center gap-4">

        <div className="w-14 h-14 rounded-2xl bg-gradient-to-l from-purple-600 to-blue-500 flex items-center justify-center text-white text-2xl">
          <FaGift />
        </div>

        <div>

          <h1 className="text-2xl md:text-3xl font-black text-white">
            دعوت دوستان
          </h1>

          <p className="mt-2 text-sm text-slate-300">
            دوستت تخفیف می‌گیرد و تو درآمد کسب می‌کنی
          </p>

        </div>
      </div>

    </section>
  );
}